import PageTitle from "@/components/PageTitle";
import DashLayout from "@/layouts/DashLayout";
import RoleProtectedPage from "@/layouts/RoleProtectedPage";
import Spinner from "@/components/Spinner";
import { useAppSelector } from "@/redux/features/hooks";
import { Roles } from "@/redux/services/user/user.type";
import SalesReportDashboard from "@/components/pos/reports/SalesReportDashboard";

function ReportsPage() {
  const currentRestaurant = useAppSelector(
    (state) => state.user.currentRestaurant
  );

  return (
    <DashLayout>
      <RoleProtectedPage
        allowedRoles={[Roles.manager, Roles.owner]}
        allowedPermissions={["reports.view"]}
      >
        <div className="space-y-6">
          <PageTitle
            title="Rapport d'activité"
            description="Tout sur l'activité de votre restaurant sur la période"
          />
          {currentRestaurant ? (
            <SalesReportDashboard restaurantId={currentRestaurant.id} />
          ) : (
            <div className="flex items-center justify-center py-12">
              <Spinner />
            </div>
          )}
        </div>
      </RoleProtectedPage>
    </DashLayout>
  );
}

export default ReportsPage;
